import React, { useEffect, useState } from 'react'
import { Button, Flex, H2, Line, SelectDropdown } from '../../lib/components'
import { walletAdminServices } from '../../services'
import { displayDollar } from '../../lib/utils/helpers'
import { ClientCell } from '../wallet-topups/client-cell'
import '../wallet-topups/wallet-admin.scss'

type WithdrawalRow = {
  id: number
  investor_id: number
  investor_name?: string | null
  investor_reference?: string | null
  amount_cents: number
  status: string
  order_id: string
}

const WalletWithdrawalsContainer = () => {
  const [status, setStatus] = useState('ORDER_PLACED')
  const [rows, setRows] = useState<WithdrawalRow[]>([])
  const [busyId, setBusyId] = useState<number | null>(null)

  const load = async (nextStatus = status) => {
    const res = await walletAdminServices.searchWithdrawals({
      status: nextStatus || undefined,
      limit: 50,
      offset: 0,
    })
    if (res?.status === 200) setRows(res.data.withdrawals || [])
  }

  useEffect(() => {
    void load()
  }, [])

  const updateStatus = async (id: number, next: string) => {
    setBusyId(id)
    try {
      await walletAdminServices.updateWithdrawalStatus(id, next)
      await load()
    } finally {
      setBusyId(null)
    }
  }

  return (
    <Flex variant='column' classes={['wallet-admin']}>
      <H2 text='Wallet withdrawals' classes={['mb-24']} />
      <div className='wallet-admin__toolbar'>
        <SelectDropdown
          name='status'
          id='wallet-withdrawal-status'
          formId=''
          value={status}
          list={[
            { text: 'Order placed', value: 'ORDER_PLACED' },
            { text: 'Approved', value: 'APPROVED' },
            { text: 'Rejected', value: 'REJECTED' },
          ]}
          handleChange={(value: string) => {
            setStatus(value)
            void load(value)
          }}
        />
      </div>
      <Line />
      {rows.length === 0 ? (
        <p className='wallet-admin__empty'>No withdrawals for this status.</p>
      ) : (
        <div className='w-100 table_scroll_horizontal'>
          <table className='styled-table'>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Client</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.order_id}</td>
                  <td>
                    <ClientCell name={row.investor_name} reference={row.investor_reference} />
                  </td>
                  <td>{displayDollar(String(row.amount_cents), 'USD', 2)}</td>
                  <td>{row.status === 'PAYMENT_SENT' ? 'APPROVED' : row.status}</td>
                  <td>
                    {row.status === 'ORDER_PLACED' ? (
                      <div className='wallet-admin__actions'>
                        <Button
                          text='Approve'
                          variant='primary-btn'
                          isDisabled={busyId === row.id}
                          handleClick={() => void updateStatus(row.id, 'APPROVED')}
                        />
                        <Button
                          text='Reject'
                          variant='secondary-btn'
                          isDisabled={busyId === row.id}
                          handleClick={() => void updateStatus(row.id, 'REJECTED')}
                        />
                      </div>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Flex>
  )
}

export { WalletWithdrawalsContainer }
